/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { standardSpinner } from '../../../../helpers/spinners'
import { standardInfoTooltip } from '../../../../helpers/tooltips'
import { positionChangeWidthSm, mediaGuidelinesHTML, mediaGuidelinesString, maximumCroppedMediaSize, maximumMediaSize, acceptsVideo } from '../../../../helpers/variableDefaults'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { returnSquareImage, returnSquareVideoThumbnail, updateAWSFileAtURL } from '../../../../helpers/imageHandling'
import { handleImageSelectUpdateMedia, handleImageSelectUpdateMediaCrop } from '../../../../helpers/commonMethods'
import { Input } from '../../../../helpers/globalHelpers'
import { saveAndCancelButtonsJSX } from '../../../../helpers/commonJSX'

export const mediaJSX = (
  mediaItem, setMediaItem,
  updatedMediaItemObj, setUpdatedMediaItemObj,
  previousMediaItem, setPreviousMediaItem,
  videoThumbnail, videoDuration,
  videoIsLoadingSquare, setVideoIsLoadingSquare,
  videoIsLoadingPortrait, setVideoIsLoadingPortrait,
  loading, setLoading, 
  saveSuccessful, setSaveSuccessful,
  errors, setErrors,
  resetLoadingAndErrors, resetSaveSuccessful,
  width
) => {


  const handleImageSelect = async (e) => {
    // console.log('handleImageSelect runs')

    resetLoadingAndErrors()

    // await handleImageSelectUpdateMedia(e, mediaItem, setMediaItem, previousMediaItem, updatedMediaItemObj, setUpdatedMediaItemObj, loading, setLoading, errors, setErrors)
    await handleImageSelectUpdateMediaCrop(e, mediaItem, setMediaItem, previousMediaItem, updatedMediaItemObj, setUpdatedMediaItemObj, loading, setLoading, errors, setErrors)

  }

  return (
    
    <Box
      sx={{
        py: 3, my: 2,
        width: '90%',
        maxWidth: '600px',
        backgroundColor: 'whitesmoke',
        borderRadius: 3, boxShadow: 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Input type="text" autoFocus="autoFocus" />
        </Box>

        {/* Media Item */}
        {mediaItem.type === 'image' &&
          <Box
            sx={{
              width: '100%',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                fontWeight: 'bold', 
                fontSize: '16px',
              }}
            >
              Square Crop
            </Typography>
            <Box 
              sx={{ 
                my: 1,
                width: width < positionChangeWidthSm ? '200px' : '200px',
                height: width < positionChangeWidthSm ? '200px' : '200px',
                backgroundImage: `url(${mediaItem.url})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                boxShadow: 3, 
                borderRadius: '5px', 
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-end', 
              }}
            />

            <Typography
              sx={{
                mt: 2,
                fontWeight: 'bold', 
                fontSize: '16px',
              }}
            >
              Portrait Crop
            </Typography>
            <Box 
              sx={{ 
                my: 1,
                width: width < positionChangeWidthSm ? '200px' : '200px',
                height: width < positionChangeWidthSm ? `${200 * (4 / 3)}px` : `${200 * (4 / 3)}px`,
                backgroundImage: `url(${'portraitURL' in mediaItem && mediaItem.portraitURL.length > 0 && mediaItem.portraitURL !== 'NA' ? mediaItem.portraitURL : mediaItem.url})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                boxShadow: 3, 
                borderRadius: '5px', 
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-end', 
              }}
            />
          </Box>
        }
        {mediaItem.type === 'video' &&
          <>
            <Typography
              sx={{
                fontWeight: 'bold', 
                fontSize: '16px',
              }}
            >
              Square Crop
            </Typography>
            <Box 
              component="video" 
              src={mediaItem.url} 
              onLoadStart={() => setVideoIsLoadingSquare(true)}
              onLoadedData={() => setVideoIsLoadingSquare(false)}
              // allow="autoPlay"
              autoPlay
              playsInline
              loop
              muted
              sx={{ 
                my: videoIsLoadingSquare ? 0 : 1,
                width: width < positionChangeWidthSm ? '200px' : '200px',
                height: videoIsLoadingSquare ? 0 : width < positionChangeWidthSm ? '200px' : '200px',
                boxShadow: videoIsLoadingSquare ? 0 : 3, 
                borderRadius: videoIsLoadingSquare ? 0 : '5px', 
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', 
              }}
            />

            {(!videoIsLoadingSquare && (('duration' in mediaItem) || videoDuration >= 0)) &&
              <Box
                sx={{
                  mt: -4, mb: 2, mx: 1,
                  backgroundColor: 'white',
                  opacity: 0.8,
                  fontSize: '14px',
                  width: '30px', maxWidth: '30px',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                {'duration' in mediaItem ? mediaItem.duration : videoDuration}s
              </Box>
            }

            {videoIsLoadingSquare &&
              <Box
                sx={{
                  // position: 'relative',
                  my: 1,
                  boxShadow: 3, 
                  borderRadius: '5px', 
                  color: 'blue',
                  width: width < positionChangeWidthSm ? '200px' : '200px',
                  height: width < positionChangeWidthSm ? '200px' : '200px',
                  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
                }}
              >
                Video is Loading...
              </Box>
            }

            <Typography
              sx={{
                mt: 2,
                fontWeight: 'bold', 
                fontSize: '16px',
              }}
            >
              Portrait Crop
            </Typography>

            
            <Box 
              component="video" 
              onLoadStart={() => setVideoIsLoadingPortrait(true)}
              onLoadedData={() => setVideoIsLoadingPortrait(false)}
              src={mediaItem.portraitURL} 
              // allow="autoPlay"
              autoPlay
              playsInline
              loop
              muted
              sx={{ 
                my: videoIsLoadingSquare ? 0 : 1,
                width: width < positionChangeWidthSm ? '200px' : '200px',
                // height: width < positionChangeWidthSm ? `${200 * (4 / 3)}px` : `${200 * (4 / 3)}px`,
                height: videoIsLoadingSquare ? 0 : width < positionChangeWidthSm ? `${200 * (4 / 3)}px` : `${200 * (4 / 3)}px`,
                boxShadow: videoIsLoadingSquare ? 0 : 3, 
                borderRadius: videoIsLoadingSquare ? 0 : '5px', 
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', 
              }}
            />

            {(!videoIsLoadingSquare && (('duration' in mediaItem) || videoDuration >= 0)) &&
              <Box
                sx={{
                  mt: -4, mb: 2, mx: 1,
                  backgroundColor: 'white',
                  opacity: 0.8,
                  fontSize: '14px',
                  width: '30px', maxWidth: '30px',
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                {'duration' in mediaItem ? mediaItem.duration : videoDuration}s
              </Box>
            }
            {videoIsLoadingSquare &&
              <Box
                sx={{
                  // position: 'relative',
                  my: 1,
                  boxShadow: 3, 
                  borderRadius: '5px', 
                  color: 'blue',
                  width: width < positionChangeWidthSm ? '200px' : '200px',
                  height: width < positionChangeWidthSm ? `${200 * (4 / 3)}px` : `${200 * (4 / 3)}px`,
                  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
                }}
              >
                Video is Loading...
              </Box>
            }
            
          </>
        }

        {/* Update Image Button */}
        {!loading.image
          && 
          <>
            <label htmlFor={'update-media-item'}>
              <Input 
                id={'update-media-item'} 
                name={'url'} 
                className={'update-media-item'} 
                accept={acceptsVideo ? 'image/*, video/*' : 'image/*'}
                type="file" 
                // multiple
                onChange={handleImageSelect}
              />
              <Button 
                variant={'contained'}
                component="span" 
                color={'primary'}
                disabled={loading.image}
                sx={{ 
                  mb: 1, mt: 2,
                  height: '45px',
                  width: '200px',
                }}
              >
                {'Update Media Item'}
              </Button>
            </label>

            {/* Media Guidelines */}
            <Box
              sx={{
                mt: 1,
                width: '90%',
                display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  // fontSize: '18px',
                  // fontWeight: 'bold',
                }}
              >
                Media Guidelines
              </Typography>
              {standardInfoTooltip(
                mediaGuidelinesHTML,
                1
              )}
            </Box>
          </>
        }

        {/* Loading */}
        {loading.image &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {errors.image &&
          <Box
            sx={{
              width: '90%', maxWidth: '450px',
            }}
          >
            {standardErrorContainer(`A selected file is larger than ${Math.round((maximumMediaSize / 1000000) * .8)}MB. Read the Media Guidelines, check your Internet connection, and try again.`)}
            
          </Box>
        }

        {/* Save Successful */}
        {saveSuccessful.image &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}